import searchStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Set the selected index of the search suggestions list
 * @param index The index of the selected suggestion
 */
export default action('setSelectedSuggestionIndex')(function setSelectedSuggestionIndex(index) {
    searchStore.selectedSuggestionIndex = index;
});
//# sourceMappingURL=setSelectedSuggestionIndex.js.map